export const figure28 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 250,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#5980c6'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },

  xAxis: {
      categories: [
"Azerbaiyán",
"Belarús",
"Bolivia (Estado Plurinacional de)",
"Bosnia y Herzegovina ",
"Colombia",
"Costa Rica",
"Ghana ",
"Guatemala",
"Italia",
"Jordania",
"Kenya",
"Liberia",
"Madagascar ",
"Malawi",
"Malí",
"Montenegro",
"Myanmar",
"Nicaragua",
"Níger",
"Macedonia del Norte",
"Pakistán",
"Paraguay",
"Perú",
"Portugal",
"Qatar",
"Rwanda",
"Serbia",
"Eslovaquia",
"Suriname",
"Suecia",
"Suiza",
"Togo",
"Uruguay",
"Uzbekistán",
"Viet Nam",
"Zimbabwe",
    ],
      title: {
          text: null
      }
  },
  yAxis: {
      min: 0,
      max: 6,
      tickInterval: 1,
      title: {
          text: null,
      },
      labels: {
          overflow: 'justify'
      }
  },
  plotOptions: {
      bar: {
          dataLabels: {
              enabled: true,
              inside: true,
              align: 'right',
          }
      }
  },
  legend: {
      enabled: false,
  },
  series: [{
      name: 'Grado',
      data: [3, 3, 5, 3, 6, 4, 1, 5, 4, 1, 5, 4, 2, 3, 3, 4, 1, 5, 2, 4, 1, 5, 5, 5, 1, 6, 5, 4, 2, 5, 4, 4, 4, 3, 4, 3],
  }]
}